import styled from 'styled-components'
import { setVh } from '../../styles/utils/conversion.style'
import { colors } from '../../styles/vars/colors.style'
import { mq } from '../../styles/vars/media-queries.style'
import { easings } from '../../styles/vars/easings.style'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { zIndex } from '../../styles/vars/zIndex.style'
import { PageTransitionLinkMain } from '../PageTransitionLink/index.style'
import { ButtonMain } from '../Button/index.style'

export const HeaderContainer = styled.header`
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${zIndex.header};
  color: ${props => (props.dark ? colors.dark : colors.light)};

  ${ButtonMain} {
    color: currentColor;
  }
`

export const HeaderInner = styled.div``

export const HeaderInnerLine = styled.span.attrs(props => ({
  style: {
    opacity: `${props.scrolled ? 1 : props.ready ? 0.2 : 1}`,
    transform: `scaleX(${props.scrolled ? 0 : props.ready ? 1 : 0})`,
    transitionDelay: `${
      props.scrolled ? 0 : props.ready && props.extraDelay ? 2.8 : 0.2
    }s`,
  },
}))`
  background-color: currentColor;
  bottom: 0;
  height: 0.1rem;
  left: 0;
  position: absolute;
  right: 0;
  transition: transform 2s ${easings.inOut.quart},
    opacity 2s ${easings.inOut.quart};
  transform-origin: 0% 0%;
  will-change: transform;
`

export const HeaderMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${clamp('height', 60, 100, breakpoints.mobile, breakpoints.contained)}

  ${mq.tabletL} {
    justify-content: flex-end;
    ${clamp('padding-right', 15, 32, breakpoints.mobile, breakpoints.contained)}
  }
`

export const HeaderLogo = styled.div`
  display: flex;
  height: 100%;
  font-size: 0;
  position: relative;
  z-index: ${zIndex.mobileNavButtons};

  ${mq.tabletL} {
    ${clamp('margin-right', 24, 37, breakpoints.tabletL, breakpoints.contained)}
    display: block;
  }

  a {
    align-items: center;
    border-bottom: 0;
    display: flex;
    height: 100%;
    ${clamp('padding-left', 15, 32, breakpoints.mobile, breakpoints.contained)}
    ${clamp('padding-right', 15, 32, breakpoints.mobile, breakpoints.contained)}
    pointer-events: all;
    transform: translateY(-8rem);

    ${props =>
      props.ready
        ? `
      transform: translateY(0);
      transition: transform 0.4s ${easings.inOut.quart},
        opacity 0.4s ${easings.inOut.quart};
      transition-delay: ${props.extraDelay ? `3s` : `.4s`};
    `
        : ``}
  }

  svg {
    ${clamp('height', 35, 41, breakpoints.mobile, breakpoints.contained)}
    ${clamp('width', 32, 38, breakpoints.mobile, breakpoints.contained)}
  }
`

export const HeaderUwcLogo = styled.div.attrs(props => ({
  style: {
    transform: `translateY(${props.scrolled ? -10 : props.ready ? 0 : -10}rem)`,
    transitionDelay: `${
      props.scrolled ? 0 : props.ready && props.extraDelay ? 3.1 : 0.5
    }s`,
  },
}))`
  display: none;
  margin-right: auto;
  pointer-events: all;
  transition: transform 0.4s ${easings.inOut.quart},
    opacity 0.4s ${easings.inOut.quart};
  will-change: transform;

  ${mq.tabletL} {
    display: block;
    ${clamp('height', 51, 64, breakpoints.tabletL, breakpoints.contained)}
    ${clamp('width', 124, 155, breakpoints.tabletL, breakpoints.contained)}

    a {
      align-items: center;
      border-bottom: 0;
      display: flex;
      height: 100%;
    }
  }

  svg {
    height: 100%;
    width: 100%;
  }
`

export const HeaderUwcLogoMobile = styled.div`
  bottom: 6rem;
  left: 50%;
  height: 6.8rem;
  position: absolute;
  transform: translateX(-50%);
  width: 15.5rem;

  a {
    align-items: center;
    border-bottom: 0;
    display: flex;
    height: 100%;
  }

  ${mq.tabletL} {
    display: none;
  }
`

export const HeaderMenu = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  text-align: right;
`

export const HeaderMenuItem = styled.li.attrs(props => ({
  style: {
    transform: `translateY(${props.scrolled ? -8 : props.ready ? 0 : -8}rem)`,
    transitionDelay: `${
      props.scrolled ? 0 : props.extraDelay ? props.longDelay : props.delay
    }s`,
  },
}))`
  ${clamp('padding-right', 15, 32, breakpoints.mobile, breakpoints.contained)}
  pointer-events: all;
  transition: transform 0.4s ${easings.out.quart},
    opacity 0.4s ${easings.out.quart};
  will-change: transform;

  ${PageTransitionLinkMain} {
    display: inline-flex;
  }
`

export const HeaderNav = styled.nav`
  display: ${props => (props.mobile ? `flex` : `none`)};

  ${mq.tabletL} {
    display: flex;
  }

  &:last-of-type {
    ${clamp('padding-left', 15, 32, breakpoints.mobile, breakpoints.contained)}
    height: 100%;
    position: relative;

    ${HeaderMenuItem} {
      ${mq.tabletL} {
        padding-right: 0;
      }
    }
  }
`

export const HeaderVerticalLine = styled.span.attrs(props => ({
  style: {
    opacity: `${props.scrolled ? 1 : props.ready ? 0.2 : 1}`,
    transform: `scaleY(${props.scrolled ? 0 : props.ready ? 1 : 0})`,
    transitionDelay: `${
      props.scrolled ? 0 : props.extraDelay ? props.longDelay : props.delay
    }s`,
  },
}))`
  background-color: currentColor;
  bottom: 0;
  display: none;
  left: ${props => (props.left ? 0 : `auto`)};
  position: absolute;
  right: ${props => (props.right ? 0 : `auto`)};
  top: 0;
  transform-origin: 0% 0%;
  transition: transform 0.4s ${easings.inOut.quart},
    opacity 0.4s ${easings.inOut.quart};
  width: 0.1rem;
  will-change: transform;

  ${mq.tabletL} {
    display: block;
  }
`

export const MobileNav = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: ${props => (props.open ? 'translateX(0)' : 'translateX(-100%)')};
  width: 100%;
  ${setVh('height', 100)}
  display: flex;
  align-items: center;
  justify-content: center;
  /* z-index: ${zIndex.mobileNav}; */
  z-index: -1;
  pointer-events: ${props => (props.open ? 'all' : 'none')};
  text-align: center;
  background-color: ${colors.darkBlue};
  transition: transform 0.2s ${easings.inOut.default};

  ${mq.tabletL} {
    display: none;
  }

  a,
  ${ButtonMain} {
    color: ${colors.light};
  }
`

export const MobileNavMain = styled.nav``

export const MobileMenu = styled.ul`
  list-style: none;
`

export const MobileMenuItem = styled.li`
  overflow: hidden;
  position: relative;
`
